function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Pen",
  opacity: 1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 303.547 370.559 L 558.797 249.609 "
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 532.797 577.641 L 304.484 371.496 "
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 527.688 213.246 L 304.938 369.164 "
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 559.062 250.207 L 529.734 212.578 "
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 558.141 250.336 L 744.719 387.281 "
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 533.516 577.781 L 743.328 388.547 "
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 534.453 577.512 L 559.656 253.922 "
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 529.078 212.180 L 743.719 384.434 "
}));

var _ref3 = /*#__PURE__*/React.createElement("style", null, "\n    .face { font: bold 120px sans-serif; }\n  ");

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 420,
  y: 380,
  className: "face",
  rotate: 40
}, "8");

var SvgD8 = function SvgD8(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3.482329in",
    height: "2.900105in",
    viewBox: "295.238251 203.716797 459.667450 382.813843",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgD8, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/D8.a62fed08.svg";
export { ForwardRef as ReactComponent };